export default {
	methods: {
		postHeight() {
			this.$nextTick(() => {
				window.parent.postMessage({
					from: 'report',
					customData: {
						author: 'Jon Snow',
						height: document.documentElement.scrollHeight || document.body.scrollHeight
					}
				}, '*')
			})
		}
	}
}